<template>
  <div class="lxm-contact-org">
    <!--<lxm-nav :title="'王小华'"></lxm-nav>-->

    <div class="page">
      <h2 class="subtitle">机构信息</h2>

      <template v-for="r in rows">
        <transition name="lxm-content-transition" mode="out-in">
          <lxm-row v-if="!loading" :name="r.name" @click="rowClicked(r)">{{ r.value }}</lxm-row>
        </transition>
      </template>
    </div>

    <contact-list :orgId="orgId"></contact-list>

    <!--<lxm-bottom-tabs></lxm-bottom-tabs>-->
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
</style>

<script>
  import LxmNav from '../common/LxmNav.vue'
  import LxmRow from '../common/LxmRow.vue'
  import LxmBottomTabs from '../common/LxmBottomTabs.vue'
  import * as aTypes from '../../../store/action-types'
  import ContactList from './List.vue'
  export default {
    components: {
      LxmNav,
      LxmRow,
      ContactList,
      LxmBottomTabs
    },
    mounted () {
      this.$store.dispatch(aTypes.CONTACT_GET_ORG, {
        contactId: this.$route.query.contactId,
        orgId: this.$route.query.orgId
      })
      this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '到达任意机构页' })
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.CONTACT_GET_ORG]
      },
      org () {
        return this.$store.state.contact.org
      },
      orgId () {
        return this.$route.query.orgId
      },
      rows () {
        return [{
          name: '名称',
          value: this.org.name
        }, {
          name: '地址',
          value: this.org.address,
          href: `http://m.amap.com/?k=${this.org.address}`
        }, {
          name: '网站',
          value: this.org.website,
          href: this.org.website
        }, {
          name: '电话',
          value: this.org.phone,
          href: `tel:${this.org.phone}`
        }, {
          name: '传真',
          value: this.org.fax
        }, {
          name: '邮箱',
          value: this.org.mail,
          href: `mailto:${this.org.mail}`
        }]
      }
    },
    methods: {
      open (href) {
        window.open(href)
      },
      rowClicked (row) {
        if (row.href) {
          this.open(row.href)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Org.vue?5989e430